import { TypedCopNode } from "../_Base";
import { NodeParamsConfig } from "../../utils/params/ParamsConfig";
class BaseCopRendererCopParamsConfig extends NodeParamsConfig {
}
const ParamsConfig = new BaseCopRendererCopParamsConfig();
export class BaseCopRendererCopNode extends TypedCopNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
}
export class CopRendererController {
  constructor(node) {
    this.node = node;
  }
  async waitForRenderer() {
    return await this.node.scene().renderersRegister.waitForRenderer();
  }
}
